export default "__VITE_PUBLIC_ASSET__b0cf39fe__"